<template lang="pug">
  b-row.page-wrap
    b-col(cols="12", md="12", lg="6" v-if="group")
      b-card.w-100(no-body)
        div(slot="header") {{$t('group')}} {{$t('information')}}
        b-list-group(flush)
          b-list-group-item
            b-row
              b-col(cols="3") {{$t('name')}}
              b-col(cols="9")
                template
                  editable(
                    name="name",
                    :value="group.name",
                    :wait="wait.name",
                    @changed="valueChange")
          b-list-group-item
            b-row
              b-col(cols="3") {{$t('manager')}}
              b-col(cols="9")
                editable(
                  name="manager_name",
                  :value="group.manager_name",
                  :wait="wait.manager_name",
                  @changed="valueChange")
          b-list-group-item
            b-row
              b-col(cols="3") {{$t('Email')}}
              b-col(cols="9")
                editable(
                  name="email",
                  :value="group.email",
                  :wait="wait.email",
                  @changed="valueChange")
          b-list-group-item
            b-row
              b-col(cols="3") {{$t('phone')}}
              b-col(cols="9")
                editable(
                  name="phone",
                  :value="group.phone",
                  :wait="wait.phone",
                  @changed="valueChange")
      // 그룹 접근 권한 사용자 목록
      b-card.w-100.mt-3.mb-3(no-body)
        div(slot="header") {{$t('list_of_users')}}
          b-btn.ml-3.setting-btn(size="sm", variant="secondary", @click="onModal" ) {{$t('settings')}}
        b-list-group(flush)
          b-table(
            ref="groupUserTable",
            :fields="fields",
            :items="groupDetailUserList",
            sort-by="userType",
            :sort-desc="false",
            responsive
          )
            template(v-slot:cell(remove)="row")
              b-button(size="sm", @click="removeUserFromGroup(row.item)")
                icon(name="minus")
    b-col(cols="12", md="12", lg="6")
      b-card-group(deck)
        // 그룹에 속한 장치 목록
        b-card.w-100(no-body)
          div(slot="header") {{$t('list_of_devices')}}
          b-list-group(flush)
            b-list-group-item.device-filter
              b-input-group.mx-1.w-100(size="sm" @keyup.enter="setFilterValue")
                template(slot="prepend")
                  b-dropdown(:text="$t(filters.key.text)", size="sm", variant="grey-200")
                    b-dropdown-item(
                      v-for="opt in filters.keyOptions",
                      :key="opt.value",
                      :style="{'font-size':'small'}",
                      @click="setFilterKey(opt)") {{$t(opt.text)}}
                b-col
                  b-form-input(
                    v-if="filters.key.value === 'alias'",
                    v-model="filterPreValue")
                  b-form-select(
                    v-model="filterPreValue",
                    v-else-if="filters.key.value === 'dev_os_id'",
                    :options="filters.osOptions")
                  b-form-select(
                    v-model="filterPreValue",
                    v-else-if="filters.key.value === 'alive'",
                    :options="filters.statusOptions")
                b-input-group-append
                  b-btn(size="sm", variant="secondary", @click="setFilterValue") {{ $t('search') }}

            b-list-group-item(
              style="height: 65px",
              v-for="dev in inGroupDev", :key="dev.pk")
                div.d-flex.w-100.justify-content-between
                  div
                    div(v-html="dev.alias", :class="dev._role ? dev._role : 'dev'")
                    small {{dev.device_group_name}}
                  div
                    b-btn(size="sm", v-if="!dev._role", @click="removeDevFromGroup(dev)")
                      icon(name="minus")

          div(slot="footer")
            b-pagination(
              size="sm",
              style="justify-content: center",
              v-model="page.inGroup.current",
              :total-rows="page.inGroup.total",
              :per-page="page.per")
        // 전체 장치 목록
        b-card.w-100(no-body)
          div(slot="header") {{$t('list_of_total_devices')}}
          b-list-group(flush)
            b-list-group-item.device-filter
              b-input-group.mx-1.w-100(size="sm" @keyup.enter="setAllDevFilter")
                template(slot="prepend")
                  b-dropdown(:text="$t(allDevFilters.key.text)", size="sm", variant="grey-200")
                    b-dropdown-item(
                      v-for="opt in allDevFilters.keyOptions",
                      :key="opt.value",
                      :style="{'font-size':'small'}",
                      @click="setAllDevFilterKey(opt)") {{$t(opt.text)}}
                b-col
                  b-form-input(
                    v-if="allDevFilters.key.value === 'alias'",
                    v-model="allDevPreFilter")
                  b-form-select(
                    v-model="allDevPreFilter",
                    v-else-if="allDevFilters.key.value === 'dev_os_id'",
                    :options="allDevFilters.osOptions")
                  b-form-select(
                    v-model="allDevPreFilter",
                    v-else-if="allDevFilters.key.value === 'alive'",
                    :options="allDevFilters.statusOptions")
                b-input-group-append
                  b-btn(size="sm", variant="secondary", @click="setAllDevFilter") {{ $t('search') }}
            b-list-group-item(
              style="height: 65px",
              v-for="dev in allDev", :key="dev.pk")
                div.d-flex.w-100.justify-content-between
                  div
                    div(v-html="dev.alias", :class="dev._role ? dev._role : 'dev'")
                    small {{dev.device_group_name}}
                  div
                    b-btn(size="sm", v-if="!dev._role", @click="addDevToGroup(dev)")
                      icon(name="plus")
                //- icon.float-right.add-button(v-if="!dev._role", name="plus", @click="addDevToGroup(dev)")
          div(slot="footer")
            b-pagination(
              size="sm",
              style="justify-content: center",
              v-model="page.all.current",
              :total-rows="page.all.total",
              :per-page="page.per")
</template>

<script>
import _ from 'lodash'
import store from '@/api/store'
import Switches from 'vue-switches'
import {DeviceAPI, DeviceGroupAPI, ConnUsersAPI, ConnDeviceGroupAPI} from '../../api'
import Editable from '../mixins/editable'
export default {
  name: 'groupdetail-component',
  components: { Editable, Switches },
  props: {
    groupPk: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    inGroupDev () {
      const groupPk = parseInt(this.groupPk)
      let devs = _.filter(this.devices, { device_group_fk: groupPk })      
      if (this.filters.value !== null) {
        devs = _.filter(devs, v => {
          let value = this.filters.value
          if (typeof value === 'number') return v[this.filters.key.value] === value
          else {
            if (!v[this.filters.key.value]) return false
            return _.includes(v[this.filters.key.value].toUpperCase(), value.toUpperCase())
          }
        })
      }
      let offset = this.page.per * (this.page.all.current - 1)
      devs = _.slice(devs, offset, offset + this.page.per)
      if (devs.length === 0) devs.push({ pk: 'no-dev-msg', alias: this.$t('no-content'), _role: 'empty' })
      if (devs.length < this.page.per) {
        while (devs.length !== this.page.per) {
          devs.push({ pk: devs.length, alias: '&nbsp;', _role: 'blank' })
        }
      }
      return devs
    },
    allDev () {
      const groupPk = parseInt(this.groupPk)
      let devs = _.filter(this.devices, v => v.device_group_fk !== groupPk)
      if (this.allDevFilters.value !== null) {
        devs = _.filter(devs, v => {
          let value = this.allDevFilters.value
          if (typeof value === 'number') return v[this.allDevFilters.key.value] === value
          else {
            if (!v[this.allDevFilters.key.value]) return false
            return _.includes(v[this.allDevFilters.key.value].toUpperCase(), value.toUpperCase())
          }
        })
      }
      let offset = this.page.per * (this.page.all.current - 1)
      devs = _.slice(devs, offset, offset + this.page.per)
      if (devs.length === 0) devs.push({ pk: 'no-dev-msg', alias: this.$t('no-content'), _role: 'empty' })
      if (devs.length < this.page.per) {
        while (devs.length !== this.page.per) {
          devs.push({ pk: devs.length, alias: '&nbsp;', _role: 'blank' })
        }
      }
      return devs
    },
    // filterDev () {
    //   const groupPk = parseInt(this.groupPk)
    //   let devs = _.filter(this.devices, { device_group_fk: groupPk })      
    //   if (this.filters.value !== null) {
    //     devs = _.filter(devs, v => {
    //       let value = this.filters.value
    //       if (typeof value === 'number') return v[this.filters.key.value] === value
    //       else {
    //         if (!v[this.filters.key.value]) return false
    //         return _.includes(v[this.filters.key.value].toUpperCase(), value.toUpperCase())
    //       }
    //     })
    //   }
    //   let offset = this.page.per * (this.page.all.current - 1)
    //   devs = _.slice(devs, offset, offset + this.page.per)
    //   if (devs.length === 0) devs.push({ pk: 'no-dev-msg', alias: this.$t('no-content'), _role: 'empty' })
    //   if (devs.length < this.page.per) {
    //     while (devs.length !== this.page.per) {
    //       devs.push({ pk: devs.length, alias: '&nbsp;', _role: 'blank' })
    //     }
    //   }
    //   return devs
    // },
    inGroupUser () {
      const groupPk = parseInt(this.groupPk)
      let users = _.filter(this.groups, {pk: groupPk})
      users = users[0].users
      let offset = this.page.per * (this.page.userInGroup.current - 1)
      users = _.slice(users, offset, offset + this.page.per)
      if (users.length === 0) users.push({ _role: 'empty' })
      if (users.length < this.page.per) {
        while (users.length !== this.page.per) {
          users.push({ pk: users.length, name: "&nbsp;",  _role: 'blank' })
        }
      }
      return users
    },
  },
  methods: {
    addThresholdHandler () {
      const values = this.addThreshold
      let params = {
        update_key: 'alert',
        alert_time: 0
      }
      if (!values.devType.value) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'please_select_device_type'}
        })
        return
      } else params.alert_code = 'I' + values.devType.value.charAt(0).toUpperCase()

      if (!values.alertType.value) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'please_select_alert_type'}
        })
        return
      } else {
        params.alert_code += values.alertType.value.number
        const allow = values.alertType.value.allow
        if (allow === 1) {
          if (!values.thTime.value) {
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'please_input_alert_time'}
            })
            return
          } else {
            // params.alert_th_value = 0
            params.alert_time = values.thTime.value
          }
        } else if (allow === 2) {
          if (!values.thValue.value) {
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'please_input_alert_value'}
            })
            return
          } else {
            params.alert_th_value = values.thValue.value
            // params.alert_time = 0
          }
        }
      }
      DeviceGroupAPI.put(`${this.groupPk}`, params)
        .then(resp => {
          this.getData()
        })
    },
    removeThresholdHandler (item) {
      let params = {
        context: {
          path: 'delete_threshold'
        },
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: 'delete'
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') return
        let params = { delete_key: item.key }
        DeviceGroupAPI.put(`${this.groupPk}`, params)
          .then(resp => {
            this.getData()
          })
      })
    },
    getUnit (key) {
      if (_.includes(key, 'Temperature')) return '℃'
      else if (_.includes(key, 'Speed')) return 'rpm'
      return '%'
    },
    getDevice () {
      const stored = store.get('devices')
      if (stored) {
        this.devices = stored.devices
        let devs = _.filter(this.devices, { device_group_fk: this.groupPk })
        this.page.inGroup.total = devs.length
        this.page.all.total = this.devices.length
      }
    },
    getUser () {
      const stored = store.get('devices')
      if (stored) {
        this.groups = stored.groups
        let grs = _.filter(this.groups, { pk: this.groupPk })
        if (grs.length == 0) {
          this.page.userInGroup.total = 0  
        } else {
          this.page.userInGroup.total = grs[0].users.length
        }
      }
    },
    removeDevFromGroup (dev) {
      let params = {
        device_pk: dev.pk,
        old_device_group_fk: dev.device_group_fk
      }
      DeviceAPI.delete('', {params})
        .then(resp => {
          let index = _.findIndex(this.devices, { pk: dev.pk })
          this.devices[index].device_group_fk = null
          this.devices[index].device_group_name = this.$t('reserved.ROOT')
          store.update('devices', ({devices}) => {
            devices[index].device_group_fk = null
            devices[index].device_group_name = this.$t('reserved.ROOT')
            this.$awn.success(this.$t('removed_device_in_group'))
          })
        })
    },
    addDevToGroup (dev) {
      let params = {
        device_pk: dev.pk,
        new_device_group_fk: this.group.pk,
        old_device_group_fk: dev.device_group_fk
      }
      DeviceAPI.post('', params)
        .then(resp => {
          let index = _.findIndex(this.devices, { pk: dev.pk })

          // console.log('node', dev) // dev는 장비 관련 정보
          console.log('devices', this.devices)
          console.log('before', this.devices[index])
          this.devices[index].device_group_fk = this.group.pk
          this.devices[index].device_group_name = this.group.name
          store.update('devices', ({devices}) => {
            devices[index].device_group_fk = this.group.pk
            devices[index].device_group_name = this.group.name
            this.$awn.success(this.$t('added_device_in_group'))
          })
        })
    },
    getData () {
      DeviceGroupAPI
        .get(`${this.groupPk}`)
        .then(resp => {
          this.group = resp.data.objects
          this.threshold.list = this.group.IW
        })
    },
    putData (key, value) {
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}]`)
      // deviceGroupAPI.put()
    },
    getUserList () {
      ConnUsersAPI
        .get('')
        .then(resp => {
          this.userList = resp.data.objects
        })
    },
    valueChange (key, value) {
      this.group[key] = value
      let params = {}
      params[key] = value
      DeviceGroupAPI.put(`${this.group.pk}`, params)
        .then(resp => {
          store.update('devices', ({groups}) => {
            let index = _.findIndex(groups, { pk: this.group.pk })
            groups[index][key] = value
            this.group[key] = value
            this.$awn.success(this.$t('changed_group_info'))
          })
        })
    },
    onModal () {
      let params = {
        title: 'LinkMeMine',
        context: {path: 'group_users_list_modal'},
        groupData: this.group,
        userList: this.userList,
      }
      this.AppState.$emit('show-list-modal-dialog', params)
    },
    removeUserFromGroup (user) {
      let params = {
        title: 'LinkMeMine',
        context: {path: 'delete_user_confirm'},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: {path: 'delete'}
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') return
        let params = {
              device_group_fk: this.group.pk,
              member_fk: user.pk
            }
        ConnDeviceGroupAPI.get('', {params})
            .then(resp => {
              this.connectedPk = resp.data.objects[0].pk
              ConnDeviceGroupAPI.delete(`${this.connectedPk}`)
                  .then(resp => {
                    DeviceGroupAPI.get('').then(resp => {
                      this.groupList = resp.data.objects
                      let index = _.findIndex(this.groupList, {pk: this.group.pk})
                      store.update('devices', ({groups}) => {
                        let storeIndex = _.findIndex(groups, {pk: this.group.pk})
                        groups[storeIndex].users = this.groupList[index].users
                        this.$awn.success(this.$t('user_in_group_remove_success'))
                        this.$refs.groupUserTable.refresh()
                      })
                    })
                  })
            })
      })
    },
    groupDetailUserList (ctx) {
      this.AppState.$on('send-group-user-data', () => {
        return this.$refs.groupUserTable.refresh()
      })
      return DeviceGroupAPI.get(`${this.groupPk}`)
          .then(resp => {
            this.group = resp.data.objects
            this.group.user.map((item) => {
              if (item.userType === 1) {
                item.userType = this.$t('department-members')
              } else if (item.userType === 2) {
                item.userType = this.$t('admin')
              } else {
                item.userType = this.$t('middle-managers')
              }
            })
            this.threshold.list = this.group.IW
            return this.group.user
          })
    },
    setFilterKey (opt) {
      this.filters.value = null
      this.filterPreValue = null
      this.filters.key = opt
    },
    setFilterValue () {      
        this.filters.value = this.filterPreValue      
    },
    setAllDevFilterKey (opt) {
      this.allDevFilters.value = null
      this.allDevPreFilter = null
      this.allDevFilters.key = opt
    },
    setAllDevFilter () {      
        this.allDevFilters.value = this.allDevPreFilter      
    }
  },
  created () {
    this.getData()
    this.getDevice()
    this.getUser()
    this.getUserList()
  },
  data () {
    return {
      devices: [],
      groups: [],
      group: null,
      context: null,
      wait: {
        name: false,
        manager_name: false,
        dev_limit: false
      },
      userList: null,
      connectedPk: null,
      threshold: {
        fields: [
          { key: 'OS', label: `${this.$t('device')} ${this.$t('type')}` },
          { key: 'Type', label: `${this.$t('alert')} ${this.$t('type')}` },
          {
            key: 'Time',
            label: `${this.$t('progress')} ${this.$t('time')}(${this.$t('minute')})`,
            thClass: 'text-right',
            tdClass: 'text-right'
          },
          {
            key: 'Threshold',
            label: this.$t('limit'),
            thClass: 'text-right',
            tdClass: 'text-right'
          },
          {
            key: 'del',
            label: this.$t('delete'),
            thClass: 'text-center',
            tdClass: 'text-center'
          }
        ]
      },
      addThreshold: {
        devType: {
          value: null,
          options: [
            { value: 'windows', text: 'windows' }
            // , { value: 'linux', text: 'linux' },
            // { value: 'mac', text: 'mac' },
            // { value: 'android', text: 'android' }
          ]
        },
        alertType: {
          value: null,
          options: [
            { value: {number: '1', allow: 1}, text: 'Disconnected' },
            { value: {number: '2', allow: 2}, text: 'CPU Usage', allow: 2 },
            { value: {number: '3', allow: 2}, text: 'Memory Usage', allow: 2 },
            { value: {number: '4', allow: 2}, text: 'Disk Usage', allow: 2 },
            { value: {number: '5', allow: 2}, text: 'CPU Temperature', allow: 2 },
            { value: {number: '6', allow: 2}, text: 'Disk Temperature', allow: 2 },
            { value: {number: '7', allow: 2}, text: 'Fan Speed', allow: 2 }
          ]
        },
        thTime: { value: null },
        thValue: { value: null }
      },
      page: {
        per: 10,
        inGroup: {
          current: 1,
          total: 0
        },
        all: {
          current: 1,
          total: 0
        },
        userInGroup: {
          current: 1,
          total: 0
        }
      },
      fields: [
        { key: 'name', label: this.$t('name'), sortable: false, thStyle: { minWidth: "100px" }},
        { key: 'mail', label: this.$t('ID'), sortable: false, thStyle: { minWidth: "100px" }},
        { key: 'userType', label: this.$t('permission'), sortable: false, thStyle: { minWidth: "100px" }},
        { key: 'remove', label: this.$t('delete'), sortable: false, thStyle: { minWidth: "80px" }},
      ],
      filterPreValue: null,
      allDevPreFilter: null,
      filters: {
        key: { value: 'alias', text: 'device_name' },
        keyOptions: [
          { value: 'alias', text: 'device_name' },
          { value: 'dev_os_id', text: 'O/S' },
          { value: 'alive', text: 'status' }
        ],
        value: null,
        osOptions: [
          { value: 1, text: 'Windows' },
          { value: 2, text: 'Linux' },
          { value: 3, text: 'MacOS'},
          { value: 4, text: 'Android' }
        ],
        statusOptions: [
          { value: 1, text: 'Online' },
          { value: 0, text: 'Offline' }
        ]
      },
      allDevFilters: {
        key: { value: 'alias', text: 'device_name' },
        keyOptions: [
          { value: 'alias', text: 'device_name' },
          { value: 'dev_os_id', text: 'O/S' },
          { value: 'alive', text: 'status' }
        ],
        value: null,
        osOptions: [
          { value: 1, text: 'Windows' },
          { value: 2, text: 'Linux' },
          { value: 3, text: 'MacOS'},
          { value: 4, text: 'Android' }
        ],
        statusOptions: [
          { value: 1, text: 'Online' },
          { value: 0, text: 'Offline' }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.device-filter{
  padding-left: 4px;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
  > .card-header {
    border-bottom: 1px solid #D2D2D2;
    font-size: 0.9rem;
    font-weight: 500;
  }
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.setting-btn {
  height: 1.5rem;
  line-height: 0.9;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.page-wrap {
  padding: 2rem 0;
}

::v-deep .b-table {
  margin: 0;

  tr, td, th {
    padding: 0.75rem 1.25rem;
    position: relative;
    font-weight: 400;
  }

  th:nth-child(1), th:nth-child(2), th:nth-child(3), th:nth-child(4), th:nth-child(5) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    width: 20% !important;
  }

  td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(5), td:nth-child(6) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6F6F6F;
  }

  td button { /* icon 요소에 대한 스타일 */
    position: absolute;
    top: 50%; /* td의 50% 높이에 위치하도록 설정 */
    transform: translateY(-50%); /* 위에서 설정한 top 값만큼 위로 이동하여 가운데 정렬 */
    /* icon 요소에 대한 스타일을 추가로 설정 */
  }
}

::v-deep .form-control, .custom-select {
  display: flex;
  background-color: #FFFFFF !important;
  border: 1px solid #6F6F6F !important;
  border-radius: 0;
  height: 1.75rem;
  align-items: center;
  text-align: left !important;
}

</style>